export default "__VITE_ASSET__b6cce3d3__"